// extracted by mini-css-extract-plugin
export default {"selectorWrapper":"versionCompareSelectorWrapper_selectorWrapper__325YO"};